import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=6e82637a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e82637a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e82637a')) {
      api.createRecord('6e82637a', component.options)
    } else {
      api.reload('6e82637a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=6e82637a&scoped=true&", function () {
      api.rerender('6e82637a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wN9idVRvSwg0/JS/comp/SearchFilterTokens.vue"
export default component.exports